import {
  IconAnalytics,
  IconAtom,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconCctvLine,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconMeter,
  IconPcLine,
  IconPlug,
  IconRoad,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTools,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import { medicalWaste1, medicalWaste2, recommendationServer } from '@assets/images/solution/recommendation';

import integrationVideo from '@src/assets/images/main/video/integration.mp4';

import image2 from '@src/assets/images/solution/medicalWaste/img/2.avif';
import image3 from '@src/assets/images/solution/medicalWaste/img/3.avif';
import image4 from '@src/assets/images/solution/medicalWaste/img/4.avif';
import image5 from '@src/assets/images/solution/medicalWaste/img/5.avif';
import image6 from '@src/assets/images/solution/medicalWaste/img/6.avif';
import image7 from '@src/assets/images/solution/medicalWaste/img/7.avif';
import image8 from '@src/assets/images/solution/medicalWaste/img/8.avif';
import image9 from '@src/assets/images/solution/medicalWaste/img/9.avif';
import recommendation from '../common/recommendation';

export default {
  type: '의료 솔루션',

  banner: {
    title: '의료 폐기물 수거부터 멸균까지, 자동화된 흐름으로 안전하게 통제하세요',
    desc: '자율주행 로봇으로 폐기물의 수거와 이동 과정을 자동화하고 감염 위험을 최소화합니다',
  },

  recommend: {
    title: '자율주행 로봇의 위치와 상태를 실시간으로 추적하고 자동 소독과 수거 흐름을 관리합니다',
    desc: '로봇에 부착된 태그와 시설 내부 수신기가 연동되어 작업 경로와 정지 지점을 수집하고, 소독 장비와 연동해 위생 처리를 자동화합니다',
    labels: {
      desktop: [
        {
          img: medicalWaste1,
          data: recommendation.twintarckerUWB,
        },
        {
          img: medicalWaste2,
          data: recommendation.uwbTag,
        },
        {
          img: recommendationServer,
          data: recommendation.server,
        },
      ],
      mobile: [
        {
          data: recommendation.uwbTag,
        },
        {
          data: recommendation.twintarckerUWB,
        },
        {
          data: recommendation.server,
        },
        {
          data: recommendation.switch,
        },
      ],
    },
  },

  video: {
    title: '로봇과 위치추적 시스템이 결합된 스마트 의료 폐기물 관리를 경험하세요.',
    desc: '로봇을 이용한 의료 폐기물 관리와 오브로 위치 추적 시스템의 통합으로 정확한 위치 모니터링 및 자동화된 관리가 가능해지며, 운영 효율성을 크게 향상시킬 수 있습니다.',
    play: integrationVideo,
  },

  func: [
    {
      theme: '로봇의 위치를 실시간으로 파악하고 의료 폐기물을 효율적으로 관리하세요.',
      title: '실시간 로봇 위치 추적 및 운영 모니터링',
      desc: '로봇의 실시간 위치와 운영 상태를 오브로 위치 추적 시스템을 통해 정확히 파악하여 의료 폐기물 관리의 정확성을 높이고 즉각적인 대응으로 운영 효율성을 극대화합니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      image: image2,
    },
    {
      title: '자율주행 기반 하역장 이동',
      desc: '로봇이 자율주행 기술을 이용하여 하역장까지 안전하게 이동하며 인력의 개입 없이 작업을 수행하여 운영 과정에서의 효율성을 높이고 작업자의 안전도 보장합니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '대응 방식 설정',
      icon2: IconBellGray,
      image: image3,
    },
    {
      title: '상차장치 자동 연동 운영',
      desc: '상차장치와 로봇 간 자동 연동 시스템을 구축하여 로봇 호출 및 상차 준비 상태를 원활하게 관리하고 작업 효율성과 처리 속도를 크게 향상시킵니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconChainLinkGray,
      image: image4,
    },
    {
      title: '스마트 보관함 연동',
      desc: '스마트 보관함과 시스템을 효과적으로 연동하여 데이터 접근과 자산 관리를 쉽고 편리하게 할 수 있으며 운영의 편의성과 정확성을 높여줍니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      theme: '장비 상태를 실시간으로 확인하고 소독 관리를 자동화하세요.',
      title: '작업 상태 실시간 모니터링',
      desc: '각 로봇의 작업 상태를 실시간으로 모니터링하여 문제가 발생할 경우 즉시 대응이 가능하며 운영 중 발생할 수 있는 오류를 최소화하여 안전한 관리 환경을 제공합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '여러대의 로봇을 동시에 관리',
      desc: '다수의 로봇을 하나의 시스템에서 동시에 관리하여 관리 효율성을 높이고 로봇 간 작업 중복 및 충돌을 방지해 정확하고 원활한 작업 진행을 지원합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '소독 시스템과의 연동 및 관리',
      desc: '플라즈마와 UVC 및 HPV 소독 장치와 간편하게 연동하여 의료 폐기물과 의료 도구의 멸균 작업을 신속하고 정확하게 수행하여 위생적인 환경을 유지합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image8,
    },
    {
      title: '기기별 작업 상태 실시간 확인',
      desc: '각 소독 장치의 연결 상태 및 작업 진행 상태를 실시간으로 정확히 모니터링하여 운영 과정 중 발생 가능한 문제를 사전에 파악하고 즉각적인 조치가 가능합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image9,
    },
  ],

  subfunc: {
    title: '기능 요약',
    desc: '',

    data: [
      {
        icon: IconRoute, // 로봇 위치 추적 → 이동 경로 기반
        title: '로봇 위치 실시간 추적',
        desc: '로봇이 별도 조작 없이 스스로 하역장까지 이동해 작업자 개입 없이 폐기물을 수거·운반합니다.',
      },
      {
        icon: IconRoute, // 자율주행 하역 이동 → 경로 기반 자율 이동
        title: '자율주행 기반 하역장 이동',
        desc: '로봇이 별도 조작 없이 스스로 하역장까지 이동해 작업자 개입 없이 폐기물을 수거·운반합니다.',
      },
      {
        icon: IconLayers, // 상차장치 연동 → 공간 내 장비 연동
        title: '상차장치 자동 연동',
        desc: '로봇이 하역장에 도착하면 상차장치와 자동 연동되어 대기 없이 폐기물이 자동 처리됩니다.',
      },
      {
        icon: IconSearch, // 보관함 연동 → 자산/위치/상태 탐색
        title: '스마트 보관함 연동',
        desc: '폐기물과 소독 자산을 스마트 보관함과 연동해 위치와 보관 상태를 자동 관리합니다.',
      },
      {
        icon: IconCctvLine, // 실시간 관제 → 모니터링 및 경고
        title: '로봇 작업 상태 실시간 관제',
        desc: '대시보드에서 로봇의 상태를 실시간 확인하고 이상 상황 발생 시 즉시 알림을 전송합니다.',
      },
      {
        icon: IconAnalytics, // 다수 제어 → 통합 제어/스케줄 분석
        title: '다수 로봇 동시 제어',
        desc: '다수의 로봇이 동시에 운영될 때도 경로, 충돌 방지, 작업 스케줄을 통합 제어할 수 있습니다.',
      },
      {
        icon: IconWarning, // 소독 장비 자동 연동 → 위생/위험 대비
        title: '소독 장비 자동 연동 위생 처리',
        desc: '플라즈마, UVC, HPV 장비와 연동돼 도착 즉시 멸균 작업이 자동 수행됩니다.',
      },
      {
        icon: IconSearch, // 기기 상태 확인 → 탐색/상태 점검
        title: '기기별 작업 상태 확인',
        desc: '각 장비의 연결 상태와 작동 상태를 실시간으로 점검할 수 있습니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'medicalPatient',
    },
    {
      data: 'retailOffice',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
